// Globals
import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';

// Components
import { StyledBadge } from './BannersListStyles';
import BannersTableActions from '../BannersTableActions/BannersTableActions';

// Models
import { IBanner } from '@/models/banners.model';
import { DEFAULT_LOCALE } from '@/models/localization.model';

// Helpers
import { formatDate } from '@/utils';
import { DateFormats } from '@/constants/dates';

type TGetBannersTableColumns = {
  t: TFunction;
  handleEditClick: (banner: IBanner) => void;
  setBannerForDelete: (banner: IBanner) => void;
  canManage: boolean;
};

export const getBannersTableColumns = ({
  t,
  handleEditClick,
  setBannerForDelete,
  canManage,
}: TGetBannersTableColumns): ColumnsType<IBanner> => [
  {
    title: t('banners_list_title'),
    dataIndex: 'name',
    key: 'name',
    render: (_, record) => record?.locale?.[DEFAULT_LOCALE]?.title,
  },
  {
    title: t('banners_list_text'),
    dataIndex: 'start_date',
    key: 'start_date',
    render: (_, record) => record?.locale?.[DEFAULT_LOCALE]?.description,
  },
  {
    title: t('banners_list_start'),
    dataIndex: 'start_date',
    key: 'start_date',
    render: (start_date) => <span>{start_date ? formatDate(start_date, DateFormats.EUROPEAN_DEFAULT) : '-'}</span>,
  },
  {
    title: t('banners_list_end'),
    dataIndex: 'expiration_date',
    key: 'expiration_date',
    render: (expiration_date) => (
      <span>{expiration_date ? formatDate(expiration_date, DateFormats.EUROPEAN_DEFAULT) : '-'}</span>
    ),
  },
  {
    title: t('banners_list_status'),
    dataIndex: 'active',
    key: 'active',
    render: (active) => (
      <StyledBadge $isActive={active}>{active ? t('banners_list_active') : t('banners_list_inactive')}</StyledBadge>
    ),
  },
  ...(canManage
    ? [
        {
          title: t('banners_list_actions'),
          key: 'actions',
          render: (_: unknown, record: IBanner) => (
            <BannersTableActions
              record={record}
              handleEditClick={handleEditClick}
              setBannerForDelete={setBannerForDelete}
            />
          ),
        },
      ]
    : []),
];
